// extracted by mini-css-extract-plugin
export default {"control":"styles_control__LDSPU","icon":"styles_icon__8whLH","focused":"styles_focused__h3lBA"};